import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { RootState } from '../../../redux/root';

// Page pills for the form. Used by the inspector's fill view and the form
// BUILDER (GenerateTemplatePopup).
//
// This bar used to carry the inspector's "Completed" toggle. It is gone: the
// outcome is now chosen once, as the inspection's Activity Status, which
// fills the form's Results row (fillLayout.applyStatusToResult) — so there is
// no separate "this report is finished" claim left to make.
const TabsBar = ({ tab, setTab }) => {
  const { selectedForm } = useSelector((s: RootState) => s.thresholdForms);

  return (
    <Wrapper>
      <Row>
        <PageTabs role="tablist">
          {selectedForm &&
            selectedForm.fileBase64 &&
            selectedForm.fileBase64.map((_item, index) => {
              const idx = `${index}`;
              const isActive = idx === tab;
              return (
                <Tab
                  key={index}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  $active={isActive}
                  onClick={() => setTab(idx)}
                >
                  Page {index + 1}
                </Tab>
              );
            })}
        </PageTabs>
      </Row>
    </Wrapper>
  );
};

export default TabsBar;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 4px;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  @media only screen and (max-width: 540px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const PageTabs = styled.div`
  display: flex;
  gap: 4px;
  background: var(--neutral-100);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 4px;
  min-width: 0;
  flex: 1 1 auto;
  overflow-x: auto;
  scrollbar-width: thin;
`;

const Tab = styled.button<{ $active: boolean }>`
  flex: 0 0 auto;
  min-width: 96px;
  height: 36px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  font-family: inherit;
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: 0.01em;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s ease, color 0.15s ease;
  background: ${({ $active }) => ($active ? 'var(--primary-600)' : 'transparent')};
  color: ${({ $active }) => ($active ? 'var(--neutral-0)' : 'var(--neutral-600)')};

  &:hover {
    background: ${({ $active }) => ($active ? 'var(--primary-700)' : 'var(--neutral-200)')};
    color: ${({ $active }) => ($active ? 'var(--neutral-0)' : 'var(--neutral-800)')};
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;
